function nwShopUrl(path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root.replace(/\/+$/, '') + '/' + String(path || '').replace(/^\/+/, '');
}

class CartReservation {
  constructor() {
    this.reservationTime = null;
    this.timerElement = null;
    this.countdownInterval = null;
    this.expirationTime = null;
    this.previousCartState = {};
    this.init();
  }

  init() {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target && event.target.classList && event.target.classList.contains('cart-drawer')) {
        this.setupTimer();
      }
    });

    document.addEventListener('cart-drawer:open', () => {
      this.setupTimer();
    });

    document.addEventListener('cart-drawer:close', () => {
      this.stopCountdown();
    });

    this.initCartMonitoring();
  }

  initCartMonitoring() {
    const originalFetch = window.fetch;

    window.fetch = async function(...args) {
      const url = args[0];
      if (typeof url === 'string' && (
        url.includes('/cart/add.js') ||
        url.includes('/cart/update.js') ||
        url.includes('/cart/change.js') ||
        url.includes('/cart/clear.js')
      )) {
        const response = await originalFetch.apply(window, args);
        const clone = response.clone();

        if (response.ok) {
          try {
            const data = await clone.json();
            if (data) {
              window.cartReservation.handleCartUpdate(data);
            }
          } catch (e) {
            console.error('Error parsing cart response:', e);
          }
        }

        return response;
      }

      return originalFetch.apply(window, args);
    };

    this.startCartPolling();
  }

  startCartPolling() {
    this.checkCartUpdates();
    setInterval(() => this.checkCartUpdates(), 2000);
  }

  async checkCartUpdates() {
    try {
      const response = await fetch(nwShopUrl('cart.json'));
      const cart = await response.json();

      if (JSON.stringify(cart) !== JSON.stringify(this.previousCartState)) {
        this.handleCartUpdate(cart);
        this.previousCartState = cart;
      }
    } catch (error) {
      console.error('Error checking cart updates:', error);
    }
  }

  handleCartUpdate(cart) {
    this.pruneOrphanGifts(cart);
    this.setupTimer();
  }

  giftVariantIds() {
    const drawer = document.querySelector('cart-drawer');
    const raw = drawer ? drawer.getAttribute('data-gift-variants') || '' : '';
    return raw.split(',').map((entry) => parseInt(entry.trim().split(':')[0], 10)).filter((id) => id > 0);
  }

  pruneOrphanGifts(cart) {
    const giftIds = this.giftVariantIds();
    if (!giftIds.length) return;
    const run = (data) => {
      if (!data || !Array.isArray(data.items) || !data.items.length) return;
      if (!data.items.every((item) => giftIds.indexOf(item.variant_id) !== -1)) return;
      if (this.pruningGifts || this.swapInFlight) return;
      this.pruningGifts = true;
      const updates = {};
      data.items.forEach((item) => { updates[item.variant_id] = 0; });
      fetch(nwShopUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      })
        .then(() => this.refreshDrawerAfterPrune())
        .catch(() => {})
        .then(() => { this.pruningGifts = false; });
    };
    if (cart && Array.isArray(cart.items)) {
      run(cart);
    } else {
      fetch(nwShopUrl('cart.js')).then((res) => res.json()).then(run).catch(() => {});
    }
  }

  async refreshDrawerAfterPrune() {
    try {
      const res = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`);
      const html = new DOMParser().parseFromString(await res.text(), 'text/html');
      const section = html.querySelector('.shopify-section');
      if (!section) return;
      const newItems = section.querySelector('cart-drawer-items');
      const currentItems = document.querySelector('cart-drawer-items');
      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
        currentItems.classList.toggle('is-empty', newItems.classList.contains('is-empty'));
      }
      const newFooter = section.querySelector('.drawer__footer');
      const currentFooter = document.querySelector('.drawer__footer');
      if (newFooter && currentFooter) currentFooter.innerHTML = newFooter.innerHTML;
      const drawer = document.querySelector('cart-drawer');
      const newDrawer = section.querySelector('cart-drawer');
      if (drawer && newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
      const bubbleRes = await fetch(`${window.Shopify.routes.root}?sections=cart-icon-bubble`);
      const bubbles = await bubbleRes.json();
      const target = document.querySelector('#cart-icon-bubble');
      if (target && bubbles && bubbles['cart-icon-bubble']) {
        const source = new DOMParser().parseFromString(bubbles['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (source) target.innerHTML = source.innerHTML;
      }
    } catch (e) {}
  }

  setupTimer() {
    this.stopCountdown();

    const storedExpiration = localStorage.getItem('cartExpirationTime');
    const hasItems = document.querySelector('cart-drawer-items:not(.is-empty)');

    if (hasItems) {
      this.waitForElement('#cart-reservation', () => {
        this.timerElement = document.getElementById('cart-reservation');
        const reservationTimeAttr = this.timerElement.getAttribute('data-cart-reservation-time');
        this.reservationTime = reservationTimeAttr ? parseInt(reservationTimeAttr) : 5;

        if (storedExpiration) {
          this.expirationTime = new Date(parseInt(storedExpiration));
          if (this.expirationTime <= new Date()) {
            this.clearCart();
            return;
          }
        } else {
          this.expirationTime = new Date(Date.now() + this.reservationTime * 60 * 1000);
          localStorage.setItem('cartExpirationTime', this.expirationTime.getTime().toString());
        }
        this.startCountdown();
      });
    } else {
      localStorage.removeItem('cartExpirationTime');
    }
  }

  waitForElement(selector, callback, maxTries = 10) {
    let tries = 0;
    const checkElement = () => {
      const element = document.querySelector(selector);
      if (element) {
        callback();
      } else if (tries < maxTries) {
        tries++;
        setTimeout(checkElement, 100);
      }
    };
    checkElement();
  }

  startCountdown() {
    if (!this.timerElement) return;

    this.updateTimer();

    this.countdownInterval = setInterval(() => {
      this.updateTimer();
    }, 1000);
  }

  stopCountdown() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
    this.expirationTime = null;
  }

  updateTimer() {
    if (!this.timerElement || !this.expirationTime) return;

    const now = new Date();
    const timeLeft = this.expirationTime - now;

    if (timeLeft <= 0) {
      this.clearCart();
      return;
    }

    const minutes = Math.floor(timeLeft / (60 * 1000));
    const seconds = Math.floor((timeLeft % (60 * 1000)) / 1000);

    this.timerElement.innerHTML = `Your cart will expire in <strong>${minutes}:${seconds.toString().padStart(2, '0')}</strong> minutes`;
  }

  async clearCart() {
    this.stopCountdown();
    localStorage.removeItem('cartExpirationTime');

    try {
      const response = await fetch(nwShopUrl('cart/clear.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    } catch (error) {
      console.error('Error clearing cart:', error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartReservation = new CartReservation();
});

window.nwCartTrack = function (eventName, params) {
  if (typeof window.omniTrack === 'function') {
    window.omniTrack(eventName, params || {});
    return;
  }
  try {
    if (typeof gtag !== 'undefined') {
      gtag('event', eventName, params || {});
    }
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(eventName, params || {});
    }
    if (typeof window.clarity === 'function') {
      window.clarity('event', eventName);
      if (params) {
        Object.keys(params).forEach(function (key) {
          window.clarity('set', eventName + '_' + key, String(params[key]));
        });
      }
    }
  } catch (e) {}
};

(function () {
  var shown = {};
  var io = null;
  var drawerEl = null;
  var mo = null;
  var observed = new WeakSet();

  function drawerOpen() {
    return !!(drawerEl && drawerEl.classList.contains('active'));
  }

  function offerKey(btn) {
    return (btn.getAttribute('data-id') || '') + '|' + (btn.getAttribute('data-is-upgrade') || '');
  }

  function fire(btn) {
    if (!drawerOpen()) return;
    var key = offerKey(btn);
    if (shown[key]) return;
    shown[key] = true;
    window.nwCartTrack('upsell_shown', {
      upsell_product: btn.getAttribute('data-product-title') || '',
      upsell_variant: ((btn.getAttribute('data-pack') || '') + ' / ' + (btn.getAttribute('data-flavor') || '')).trim(),
      upsell_type: btn.getAttribute('data-is-upgrade') === 'true' ? 'upgrade' : 'add'
    });
  }

  function scan() {
    if (!io) return;
    if (!drawerOpen()) {
      io.disconnect();
      observed = new WeakSet();
      return;
    }
    drawerEl.querySelectorAll('.upsell-cta').forEach(function (btn) {
      if (observed.has(btn)) return;
      observed.add(btn);
      io.observe(btn);
    });
  }

  function onMutation(records) {
    var classChanged = records.some(function (r) {
      return r.type === 'attributes' && r.target === drawerEl;
    });
    if (classChanged && !drawerOpen()) shown = {};
    scan();
  }

  function bind() {
    var el = document.querySelector('cart-drawer');
    if (!el || el === drawerEl) return;
    drawerEl = el;
    if (mo) mo.disconnect();
    mo = new MutationObserver(onMutation);
    mo.observe(drawerEl, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    scan();
  }

  function init() {
    if (!('IntersectionObserver' in window) || !('MutationObserver' in window)) return;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && entry.target.offsetParent !== null) fire(entry.target);
      });
    }, { threshold: 0.5 });
    bind();
    document.addEventListener('cart:refreshed', bind);
    document.addEventListener('shopify:section:load', bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.addEventListener('click', function (e) {
  if (e.target.closest('#CartDrawer-Checkout')) {
    window.nwCartTrack('cart_drawer_checkout_click');
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.upsell-cta');
    if (!btn) return;
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    const variantId = btn.getAttribute('data-id');
    const sellingPlan = btn.getAttribute('data-selling-plan');
    const isUpgrade = btn.getAttribute('data-is-upgrade') === 'true';
    const currentItemKey = btn.getAttribute('data-current-item-key') || '';
    const discountCode = btn.getAttribute('data-discount-code');
    const landingConfig = btn.getAttribute('data-landing-config');
    const upsellLabel = ((btn.getAttribute('data-pack') || '') + ' / ' + (btn.getAttribute('data-flavor') || '')).trim();
    const upsellTitle = btn.getAttribute('data-product-title') || '';

    const buttonText = btn.querySelector('.button-text');
    const buttonSpinner = btn.querySelector('.button-spinner');

    const showLoading = () => {
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
      if (buttonText) {
        btn.setAttribute('aria-label', buttonText.textContent.trim());
        buttonText.style.display = 'none';
      }
      if (buttonSpinner) buttonSpinner.style.display = 'inline-block';
    };

    const hideLoading = () => {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('aria-label');
      if (buttonText) buttonText.style.display = '';
      if (buttonSpinner) buttonSpinner.style.display = 'none';
    };

    const addToCart = async () => {
      const body = {
        items: [{
          id: parseInt(variantId),
          quantity: 1,
          ...(sellingPlan ? { selling_plan: parseInt(sellingPlan) } : {}),
          properties: {
            '_landing_config': landingConfig || 'default',
            '_upsell': upsellLabel || 'true'
          }
        }]
      };

      const res = await fetch(nwShopUrl('cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      return res.ok;
    };

    const applyDiscount = async (code) => {
      if (!code) return;
      await window.nwApplyDiscount(code);
    };

    const refreshCartDrawer = async () => {
      await new Promise(resolve => setTimeout(resolve, 300));

      const res = await fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`);
      const responseText = await res.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      const shopifySection = html.querySelector('.shopify-section');
      if (!shopifySection) return;

      const newCartItems = shopifySection.querySelector('cart-drawer-items');
      const currentCartItems = document.querySelector('cart-drawer-items');
      if (newCartItems && currentCartItems) {
        currentCartItems.innerHTML = newCartItems.innerHTML;
      }

      const newFooter = shopifySection.querySelector('.drawer__footer');
      const currentFooter = document.querySelector('.drawer__footer');
      if (newFooter && currentFooter) {
        currentFooter.innerHTML = newFooter.innerHTML;
      }

      const cartIconBubbleRes = await fetch(`${window.Shopify.routes.root}?sections=cart-icon-bubble`);
      const cartIconBubbleSections = await cartIconBubbleRes.json();
      if (cartIconBubbleSections && cartIconBubbleSections['cart-icon-bubble']) {
        const bubbleHtml = new DOMParser().parseFromString(cartIconBubbleSections['cart-icon-bubble'], 'text/html');
        const targetBubble = document.querySelector('#cart-icon-bubble');
        const sourceBubble = bubbleHtml.querySelector('.shopify-section');
        if (targetBubble && sourceBubble) {
          targetBubble.innerHTML = sourceBubble.innerHTML;
        }
      }

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('shopify:section:load'));
      }, 100);
    };

    showLoading();
    if (window.cartReservation) window.cartReservation.swapInFlight = true;

    try {
      if (isUpgrade && !currentItemKey) {
        const clearRes = await fetch(nwShopUrl('cart/clear.js'), { method: 'POST' });
        if (!clearRes.ok) {
          hideLoading();
          return;
        }
      }

      const success = await addToCart();

      if (success && isUpgrade && currentItemKey) {
        await fetch(nwShopUrl('cart/change.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: currentItemKey, quantity: 0 })
        });
      }

      if (success) {
        window.nwCartTrack('cart_upsell_added', {
          upsell_product: upsellTitle,
          upsell_variant: upsellLabel,
          upsell_type: isUpgrade ? 'upgrade' : 'add'
        });
        if (discountCode) {
          await applyDiscount(discountCode);
        }
        await refreshCartDrawer();
      }
    } catch (err) {
      console.error('Error during upgrade:', err);
    } finally {
      if (window.cartReservation) window.cartReservation.swapInFlight = false;
      hideLoading();
    }
  });
});

// Shopify applies /discount/<code> asynchronously: the cart can still report the
// old totals for a moment after the request resolves, which renders the drawer
// from a stale cart. Poll until the code lands, but never make the shopper wait
// past NW_DISCOUNT_DEADLINE_MS - a missing discount must not stall the drawer.
var NW_DISCOUNT_DEADLINE_MS = 1500;

function nwDiscountSettled(code, deadline) {
  return fetch(nwShopUrl('cart.js'), { headers: { Accept: 'application/json' } })
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      var applied = (cart.discount_codes || []).some(function (entry) {
        return entry.code && entry.code.toLowerCase() === code.toLowerCase() && entry.applicable;
      });
      if (applied || Date.now() >= deadline) return applied;
      return new Promise(function (resolve) { setTimeout(resolve, 150); })
        .then(function () { return nwDiscountSettled(code, deadline); });
    })
    .catch(function () { return false; });
}

window.nwApplyDiscount = function (code) {
  if (!code) return Promise.resolve(false);
  var deadline = Date.now() + NW_DISCOUNT_DEADLINE_MS;
  return fetch(nwShopUrl('discount/' + encodeURIComponent(code)), {
    method: 'GET',
    redirect: 'follow'
  })
    .then(function () {
      if (Date.now() >= deadline) return false;
      return nwDiscountSettled(code, deadline);
    })
    .catch(function () { return false; });
};

window.nwAnnounceCart = function (message) {
  var region = document.getElementById('CartDrawer-LiveRegionText');
  if (!region || !message) return;
  region.setAttribute('aria-hidden', 'false');
  region.textContent = '';
  setTimeout(function () { region.textContent = message; }, 50);
};

window.nwCartDrawerOpened = function (trigger) {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  var opener = trigger && trigger.focus ? trigger : document.activeElement;
  if (opener && opener !== document.body && !drawer.contains(opener) && typeof drawer.setActiveElement === 'function') {
    drawer.setActiveElement(opener);
  }
  var done = false;
  var run = function () {
    if (done) return;
    if (typeof trapFocus !== 'function' || !drawer.classList.contains('active')) return;
    var box = drawer.classList.contains('is-empty')
      ? drawer.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');
    var target = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
    if (!box || !target) return;
    trapFocus(box, target);
    if (!box.contains(document.activeElement)) return;
    done = true;
    if (window.cartStrings && window.cartStrings.itemAdded) window.nwAnnounceCart(window.cartStrings.itemAdded);
  };
  drawer.addEventListener('transitionend', run, { once: true });
  setTimeout(run, 350);
  setTimeout(run, 700);
};

window.nwOpenCartDrawer = function (trigger) {
  var opener = trigger && trigger.focus ? trigger : document.activeElement;
  return fetch(nwShopUrl('cart?section_id=cart-drawer'))
    .then(function (res) {
      if (!res.ok) throw new Error('Failed to fetch cart drawer');
      return res.text();
    })
    .then(function (htmlString) {
      var html = new DOMParser().parseFromString(htmlString, 'text/html');
      var current = document.querySelector('#CartDrawer');
      var empty = document.querySelector('.drawer__inner-empty');
      if (empty) empty.remove();

      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('is-empty')) {
        drawer.classList.remove('is-empty');
      }

      var next = html.querySelector('#CartDrawer');
      if (next && current) current.replaceWith(next);

      var refreshed = document.querySelector('cart-drawer');
      if (refreshed) {
        refreshed.classList.add('active');
        window.nwCartDrawerOpened(opener);
      }

      requestAnimationFrame(function () {
        document.dispatchEvent(new CustomEvent('cart:refreshed'));
        requestAnimationFrame(function () {
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        });
      });
    })
    .catch(function (err) {
      console.error('Error refreshing cart drawer:', err);
      window.location.href = nwShopUrl('cart');
    });
};

